import React, { useEffect, useState } from "react";
import "./recruitmentProcess.scss";
import UploadVideo from "./UploadVideo";
import { doLogin } from "../../../actions/feedActions";
import { connect } from "react-redux";
import {
  getNewTeacher,
  teacherForm,
  teacherFormSubmit,
  teacherProfileUpdate,
} from "../../../actions/tutorFeedActions";
import {
  fileUpload,
  fileUploadAfterSignURL,
  generateSignUrl,
  getToken,
} from "../../../actions/emActions";
import { Spinner } from "reactstrap";
import $ from "jquery";

const RecruitmentTab = (props) => {
  const [introVideoFile, setintroVideoFile] = useState(null);
  const [introVideoPreview, setintroVideoPreview] = useState("");
  const [topicExplainVideoFile, settopicExplainVideoFile] = useState(null);
  const [topicExplainPreview, settopicExplainPreview] = useState("");
  const [teacherId, setteacherId] = useState("");
  const [teacherInfo, setteacherInfo] = useState("");
  const [loginLoader, setloginLoader] = useState(false);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [gender, setgender] = useState("");
  const [dob, setdob] = useState("");
  const [year, setyear] = useState("");
  const [month, setmonth] = useState("");
  const [day, setday] = useState("");
  const [number, setnumber] = useState("");
  const [recruitmentId, setrecruitmentId] = useState("");
  const [education, seteducation] = useState("");
  const [experience, setexperience] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [uploadLoader, setuploadLoader] = useState(false);
  const [upload2ndLoader, setupload2ndLoader] = useState(false);
  const [addedVideo, setaddedVideo] = useState("");
  const [addedVideo2, setaddedVideo2] = useState("");
  const [endpointLoader, setendpointLoader] = useState(false);
  const [snackbarMessage, setsnackbarMessage] = useState("");
  const [snackbarColor, setsnackbarColor] = useState("#01ac8a");
  const [snackbar, setsnackbar] = useState();

  const { username, password } = props.match.params;

  useEffect(() => {
    if (username && password) {
      setloginLoader(true);
      const loginUserInfo = {
        user_loginname: username,
        user_type: 1,
      };
      props.doLogin(username, password, 1);
      localStorage.setItem("userEmail", username);
      localStorage.setItem("userPassword", password);
      localStorage.setItem("loginUserInfo", JSON.stringify(loginUserInfo));
      setTimeout(() => {
        props.history.push("/TeacherDashboard/RecruitmentTab");
        window.location.reload();
        setloginLoader(false);
      }, 3000);
    }
  }, [username, password]);

  useEffect(() => {
    setendpointLoader(true);
    const loginInfo = localStorage.getItem("loginData");
    if (loginInfo && loginInfo) {
      const teacherId = JSON.parse(loginInfo).user?.user_id;
      getToken(teacherId).then((res) => {
        localStorage.setItem("loginToken", res.data.accessToken);
        setteacherId(teacherId);
        getNewTeacher(teacherId, res.data.accessToken).then((res2) => {
          if (res2.status === 200) {
            setteacherInfo(res2.data);
            setname(res2?.data?.teacher?.user_name);
            setemail(res2?.data?.teacher?.user_email);
            setnumber(res2?.data?.teacher?.lm_candidate_profile[0]["phone"]);
            setgender(res2?.data?.teacher?.lm_candidate_profile[0]["gender"]);
            setyear(res2?.data?.teacher?.lm_candidate_profile?.[0]?.["dob"]?.split("-")?.[0]);
            setmonth(res2?.data?.teacher?.lm_candidate_profile?.[0]?.["dob"]?.split("-")?.[1]);
            setday(res2?.data?.teacher?.lm_candidate_profile?.[0]?.["dob"]?.split("-")?.[2]);
            setrecruitmentId(res2?.data?.id);

            if (res2?.data?.teacher_form) {
              const educationData = res2?.data?.teacher_form.find(
                (item) => item.question === "Education"
              );
              const experienceData = res2?.data?.teacher_form.find(
                (item) => item.question === "Experience"
              );
              const gradesData = res2?.data?.teacher_form.find(
                (item) => item.question === "Teaching Grades"
              );
              const introductoryVideoData = res2?.data?.teacher_form.find(
                (item) => item.question === "Introductory Video"
              );

              const topicVideoData = res2?.data?.teacher_form.find(
                (item) => item.question === "Topic Video"
              );

              if (educationData) {
                seteducation(educationData.answer);
              }

              if (experienceData) {
                setexperience(experienceData.answer);
              }

              if (gradesData) {
                setSelectedSubjects(JSON.parse(gradesData?.answer));
              }

              if (introductoryVideoData) {
                setaddedVideo(introductoryVideoData?.answer);
              }

              if (topicVideoData) {
                setaddedVideo2(topicVideoData?.answer);
              }
              setendpointLoader(false);
            }
          }
        });
      });
    }
  }, []);

  // Event handler for the subject checkboxes
  const handleSubjectChange = (event) => {
    const subject = event.target.value;
    if (selectedSubjects.includes(subject)) {
      setSelectedSubjects(selectedSubjects.filter((item) => item !== subject));
      sendFormFields(
        "Teaching Grades",
        JSON.stringify(selectedSubjects.filter((item) => item !== subject)),
        1
      );
    } else {
      setSelectedSubjects([...selectedSubjects, subject]);
      sendFormFields("Teaching Grades", JSON.stringify([...selectedSubjects, subject]), 1);
    }
  };

  console.log("Subjects", selectedSubjects);

  const handleIntroVideo = (event) => {
    const file = event[0];

    if(file?.type?.includes('video/mp4')){
    setintroVideoFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setintroVideoPreview(reader.result);
    };
    reader.readAsDataURL(file);
  }
  else {
    setsnackbarMessage("We recommend using high quality .mp4 files");
    setsnackbar(true);
    setsnackbarColor("#fb0606");
    setTimeout(() => {
      setsnackbar(false);
    }, 2000);
  }
  };

  const handleExplanVideo = (event) => {
    const file = event[0];

    if(file?.type?.includes('video/mp4')){
    settopicExplainVideoFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      settopicExplainPreview(reader.result);
    };
    reader.readAsDataURL(file);
  }
  else {
    setsnackbarMessage("We recommend using high quality .mp4 files");
    setsnackbar(true);
    setsnackbarColor("#fb0606");
    setTimeout(() => {
      setsnackbar(false);
    }, 2000);
  }
  };

  const uploadIntroFunc = () => {
    setuploadLoader(true);
    generateSignUrl(
      `IntroVideo-${introVideoFile?.name}`,
      "tutor",
      introVideoFile?.type,
      "Recruitment",
      teacherId.toString()
    )
      .then((res) => {
        debugger;
        fileUploadAfterSignURL(res?.data?.signurl, introVideoFile).then((res2) => {
          if (res2.status === 200) {
            sendFormFields("Introductory Video", res?.data?.url, 0);
            setuploadLoader(false);
            setsnackbarMessage("Intro Video Uploaded Successfully");
            setsnackbar(true);
            setTimeout(() => {
              setsnackbar(false);
              setsnackbarColor("#01ac8a");
            }, 2000);
          }
        });
      })
      .catch((err) => {
        window.alert("Some Error Occurred", err);
        setuploadLoader(false);
      });
  };
  // const uploadIntroFunc = () => {
  //   setuploadLoader(true);
  //   fileUpload(introVideoFile, teacherId, "tutor")
  //     .then((res) => {
  //       sendFormFields("Introductory Video", res?.data[0]?.url, 0);
  //       setuploadLoader(false);
  //       setsnackbarMessage("Intro Video Uploaded Successfully");
  //       setsnackbar(true);
  //       setTimeout(() => {
  //         setsnackbar(false);
  //         setsnackbarColor("#01ac8a");
  //       }, 2000);
  //     })
  //     .catch((err) => {
  //       window.alert("Some Error Occurred", err);
  //       setuploadLoader(false);
  //     });
  // };

  const uploadTopicFunc = () => {
    setupload2ndLoader(true);
    generateSignUrl(
      `TopicVideo-${topicExplainVideoFile?.name}`,
      "tutor",
      topicExplainVideoFile?.type,
      "Recruitment",
      teacherId.toString()
    )
      .then((res) => {
        debugger;
        fileUploadAfterSignURL(res?.data?.signurl, topicExplainVideoFile).then((res2) => {
          if (res2.status === 200) {
            sendFormFields("Topic Video", res?.data?.url, 0);
            setupload2ndLoader(false);
            setsnackbarMessage("Topic Video Uploaded");
            setsnackbar(true);
            setTimeout(() => {
              setsnackbar(false);
              setsnackbarColor("#01ac8a");
            }, 2000);
          }
        });
      })
      .catch((err) => {
        window.alert("Some Error Occurred", err);
        setupload2ndLoader(false);
      });
  };
  // const uploadTopicFunc = () => {
  //   setupload2ndLoader(true);
  //   fileUpload(topicExplainVideoFile, teacherId, "tutor")
  //     .then((res) => {
  //       setsnackbarMessage("Topic Video Uploaded");
  //       setsnackbar(true);
  //       setTimeout(() => {
  //         setsnackbar(false);
  //         setsnackbarColor("#01ac8a");
  //       }, 2000);
  //       sendFormFields("Topic Video", res?.data[0]?.url, 0);
  //       setupload2ndLoader(false);
  //     })
  //     .catch((err) => {
  //       window.alert("Some Error occered", err);
  //       setuploadLoader(false);
  //     });
  // };

  const sendFormFields = (question, answer, questionType) => {
    teacherForm(teacherId, recruitmentId, question, answer, questionType).then((res) => {
      debugger;
    });
  };

  useEffect(() => {
    if (education) {
      sendFormFields("Education", education, 0);
    }
  }, [education]);

  useEffect(() => {
    if (experience) {
      sendFormFields("Experience", experience, 0);
    }
  }, [experience]);

  const updateInfoFunc = () => {
    const date = `${year}/${month}/${day}`;

    teacherProfileUpdate(name, email, number, gender, date, teacherId).then((res) => {
      if (res?.status === 201) {
        setsnackbarMessage("Info Updated Successfully");
        setsnackbar(true);
        setTimeout(() => {
          setsnackbar(false);
          setsnackbarColor("#01ac8a");
        }, 2000);
      } else {
        setsnackbarMessage("Error!");
        setsnackbar(true);
        setsnackbarColor("#fb0606");
        setTimeout(() => {
          setsnackbar(false);
        }, 2000);
      }
      debugger;
    });
  };

  const teacherFormSubmitFunc = () => {
    teacherFormSubmit(teacherId, recruitmentId).then((res) => {
      debugger;
      if (res?.status === 201) {
        setsnackbarMessage("Form Submitted Successfully");
        setsnackbar(true);
        setsnackbarColor("#01ac8a");
        $("#timeTableUpdated").modal("show");
        setTimeout(() => {
          setsnackbar(false);
        }, 2000);
      } else {
        setsnackbarMessage("Error!");
        setsnackbar(true);
        setsnackbarColor("#fb0606");
        setTimeout(() => {
          setsnackbar(false);
        }, 2000);
      }
    });
  };

  console.log("teacherInfo", teacherInfo);
  return loginLoader ? (
    <div className="text-center">
      <div className="mt-5">
        <label className="font-weight-bold">We are logging you in...</label>
      </div>
      <Spinner size="md" />
    </div>
  ) : (
    <div>
      <div className="tutorBanner mt-2">
        <h4>Become an Online Tutor</h4>
        <br />
        <div className="">
          <p>Hello! We would love for you to be a part of our team.</p>
          <p>
            Please fill out the form below. Make sure you answer all the questions to be a part of
            the talent pipeline.
          </p>
          <p>Our team will get in touch with you if you are shortlisted for the next steps.</p>
        </div>
      </div>

      {endpointLoader ? (
        <div className="text-center mt-3">
          <Spinner size="md" />
        </div>
      ) : (
        <div className="questonsCard">
          <div className="modalForZoomLink">
            <div class="modal fade" tabindex="-1" role="dialog" id="timeTableUpdated">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body">
                    <div className="text-center">
                      <i className="fas fa-check-circle-o mr-3 fa-4x text-success"></i>
                      <h5 className="font-weight-bold mt-3">
                        Your details has been submitted successfully!
                      </h5>
                      <br />
                      <p> (We will contact you soon) </p>
                    </div>
                    <div className="text-center">
                      <button
                        className="btn btn-success btn-block"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => window.location.reload()}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={snackbar ? "show" : ""}
            id="snackbar"
            style={{ backgroundColor: snackbarColor }}
          >
            {snackbarMessage}
          </div>
          <div>
            <h5 className="font-weight-bold">Personal Information:</h5>
            <hr />
            <div className="form-group">
              <label>Name:</label>
              <br />
              <input
                onChange={(e) => setname(e.target.value)}
                value={name}
                className="form-control"
                type="text"
              />
            </div>
            <div className="form-group">
              <label>Email:</label>
              <br />
              <input
                onChange={(e) => setemail(e.target.value)}
                value={email}
                className="form-control"
                type="text"
              />
            </div>
            <div className="form-group">
              <label>Phone number:</label>
              <br />
              <input
                onChange={(e) => setnumber(e.target.value)}
                value={number}
                className="form-control"
                type="text"
              />
            </div>
            <div className="form-group">
              <label>Date of birth:</label>
              <br />
              <div className="row">
                <div className="col-4 col-sm-2">
                  <select
                    className="form-control"
                    type="select"
                    name="b_date"
                    id="b_date"
                    style={{
                      borderColor: "#176B87",
                    }}
                    value={day}
                    onChange={(evt) => setday(evt.target.value)}
                  >
                    <option value="" disabled selected>
                      Day
                    </option>
                    <option value="01">1</option>
                    <option value="02">2</option>
                    <option value="03">3</option>
                    <option value="04">4</option>
                    <option value="05">5</option>
                    <option value="06">6</option>
                    <option value="07">7</option>
                    <option value="08">8</option>
                    <option value="09">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                </div>

                <div className="col-4 col-sm-2">
                  <select
                    className="form-control"
                    type="select"
                    name="b_month"
                    id="b_month"
                    style={{
                      borderColor: "#176B87",
                    }}
                    value={month}
                    onChange={(evt) => setmonth(evt.target.value)}
                  >
                    <option value="" disabled selected>
                      Month
                    </option>
                    <option value="01">1</option>
                    <option value="02">2</option>
                    <option value="03">3</option>
                    <option value="04">4</option>
                    <option value="05">5</option>
                    <option value="06">6</option>
                    <option value="07">7</option>
                    <option value="08">8</option>
                    <option value="09">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                </div>
                <div className="col-4 col-sm-2">
                  <select
                    className="form-control form-control "
                    type="select"
                    name="b_year"
                    id="b_year"
                    style={{
                      borderColor: "#176B87",
                    }}
                    value={year}
                    onChange={(evt) => setyear(evt.target.value)}
                  >
                    <option value="" disabled selected>
                      Year
                    </option>
                    <option value="2004">2004</option>
                    <option value="2003">2003</option>
                    <option value="2002">2002</option>
                    <option value="2001">2001</option>
                    <option value="2000">2000</option>
                    <option value="1999">1999</option>
                    <option value="1998">1998</option>
                    <option value="1997">1997</option>
                    <option value="1996">1996</option>
                    <option value="1995">1995</option>
                    <option value="1994">1994</option>
                    <option value="1993">1993</option>
                    <option value="1992">1992</option>
                    <option value="1991">1991</option>
                    <option value="1990">1990</option>
                    <option value="1989">1989</option>
                    <option value="1988">1988</option>
                    <option value="1987">1987</option>
                    <option value="1986">1986</option>
                    <option value="1985">1985</option>
                    <option value="1984">1984</option>
                    <option value="1983">1983</option>
                    <option value="1982">1982</option>
                    <option value="1981">1981</option>
                    <option value="1980">1980</option>
                    <option value="1979">1979</option>
                    <option value="1978">1978</option>
                    <option value="1977">1977</option>
                    <option value="1976">1976</option>
                    <option value="1975">1975</option>
                    <option value="1973">1973</option>
                    <option value="1972">1972</option>
                    <option value="1971">1971</option>
                    <option value="1974">1974</option>
                    <option value="1973">1973</option>
                    <option value="1972">1972</option>
                    <option value="1971">1971</option>
                    <option value="1970">1970</option>
                    <option value="1969">1969</option>
                    <option value="1968">1968</option>
                    <option value="1967">1967</option>
                    <option value="1966">1966</option>
                    <option value="1965">1965</option>
                    <option value="1964">1964</option>
                    <option value="1963">1963</option>
                    <option value="1962">1962</option>
                    <option value="1961">1961</option>
                    <option value="1960">1960</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>Gender:</label>
              <br />
              <button
                onClick={() => setgender(1)}
                value={gender}
                className={gender === 1 ? "genderBtn active" : "genderBtn"}
              >
                Male
              </button>
              <button
                onClick={() => setgender(2)}
                value={gender}
                className={gender === 2 ? "genderBtn active" : "genderBtn"}
              >
                Female
              </button>
              <button
                onClick={() => setgender(0)}
                value={gender}
                className={gender === 0 ? "genderBtn active" : "genderBtn"}
              >
                Non-binary
              </button>
            </div>
            <div className="text-right">
              <button className="btn btn-sm btn-success" onClick={() => updateInfoFunc()}>
                Update Personal Information
              </button>
            </div>
            <div className="mt-2">
              <h5 className="font-weight-bold">Teaching Information:</h5>
              <hr />
            </div>
            <div className="form-group">
              <label>Education:</label>
              <br />
              <div class="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value={"A level"}
                  checked={education === "A level"}
                  onChange={() => seteducation("A level")}
                />
                <label class="form-check-label" for="exampleRadios1">
                  A level
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="A level"
                  checked={education === "Bachelors"}
                  onChange={() => seteducation("Bachelors")}
                />
                <label class="form-check-label" for="exampleRadios2">
                  Bachelors
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Masters"
                  checked={education === "Masters"}
                  onChange={() => seteducation("Masters")}
                />
                <label class="form-check-label" for="exampleRadios3">
                  Masters
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Others"
                  checked={education === "Others"}
                  onChange={() => seteducation("Others")}
                />
                <label class="form-check-label" for="exampleRadios4">
                  Others
                </label>
              </div>
            </div>
            <div className="form-group">
              <label>Do you have any previous experience in teaching?</label>
              <br />
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value={"No"}
                  checked={experience === "No"}
                  onChange={() => setexperience("No")}
                />
                <label class="form-check-label" for="exampleRadios1">
                  No
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value={"1-2 years"}
                  checked={experience === "1-2 years"}
                  onChange={() => setexperience("1-2 years")}
                />
                <label class="form-check-label" for="exampleRadios2">
                  1-2 years
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value={"3-5 years"}
                  checked={experience === "3-5 years"}
                  onChange={() => setexperience("3-5 years")}
                />
                <label class="form-check-label" for="exampleRadios3">
                  3-5 years
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value={"More than 5 years"}
                  checked={experience === "More than 5 years"}
                  onChange={() => setexperience("More than 5 years")}
                />
                <label class="form-check-label" for="exampleRadios4">
                  More than 5 years
                </label>
              </div>
            </div>
            <div className="form-group">
              <label> Which grade(s) are you comfortable teaching?</label>
              <br />
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Primary"
                  checked={selectedSubjects.includes("Primary")}
                  onChange={handleSubjectChange}
                />
                <label class="form-check-label" for="defaultCheck1">
                  Primary (KG - Grade 5)​​​​​​​​​​​​​​
                </label>
              </div>
              {selectedSubjects.includes("Primary") && (
                <div className="form-group ml-3 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="English (Primary)"
                      checked={selectedSubjects.includes("English (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      English​​​​​​​​​​​​​​
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Math (Primary)"
                      checked={selectedSubjects.includes("Math (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Math​​​​​​​​​​​​​​​​​​​​​
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Science (Primary)"
                      checked={selectedSubjects.includes("Science (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Science
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Creative Writing (Primary)"
                      checked={selectedSubjects.includes("Creative Writing (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Creative Writing
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="AI (Primary)"
                      checked={selectedSubjects.includes("AI (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      AI
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="defaultCheck1"
                      value="Coding (Primary)"
                      checked={selectedSubjects.includes("Coding (Primary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Coding
                    </label>
                  </div>
                </div>
              )}
              <div class="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="Secondary"
                  checked={selectedSubjects.includes("Secondary")}
                  onChange={handleSubjectChange}
                />
                <label class="form-check-label" for="defaultCheck1">
                  Secondary (Grade 6- Grade 11)​​​​​​​​​​​​​​​​​​​​​
                </label>
              </div>
              {selectedSubjects.includes("Secondary") && (
                <div className="form-group ml-3 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="English​​​​​​​​​​ (Secondary)​"
                      checked={selectedSubjects.includes("English​​​​​​​​​​ (Secondary)​")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      English​​​​​​​​​​​​​​
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Math (Secondary)"
                      checked={selectedSubjects.includes("Math (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Math​​​​​​​​​​​​​​​​​​​​​
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Science (Secondary)"
                      checked={selectedSubjects.includes("Science (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Science
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Creative Writing (Secondary)"
                      checked={selectedSubjects.includes("Creative Writing (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="default   Check1">
                      Creative Writing
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="AI (Secondary)"
                      checked={selectedSubjects.includes("AI (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      AI
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="Coding (Secondary)"
                      checked={selectedSubjects.includes("Coding (Secondary)")}
                      onChange={handleSubjectChange}
                    />
                    <label class="form-check-label" for="defaultCheck1">
                      Coding
                    </label>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-md-6">
                <label style={{ fontSize: 20, fontWeight: 500 }}>View this sample video:</label>
                <div className="text-center mt-3">
                <video preload="metadata" className="w-100" playsInline controls>
                    <source src={`https://lincolnmethod.s3.amazonaws.com/Teacher+video+examples.mp4#t=0.001`} />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <UploadVideo
                  selectedFile={introVideoFile}
                  setSelectedFile={setintroVideoFile}
                  preview={introVideoPreview}
                  handleFileChange={handleIntroVideo}
                  uploadFunc={uploadIntroFunc}
                  headingText="Video About Me"
                  loader={uploadLoader}
                  addedVideo={addedVideo}
                />
              </div>
              <div className="col-md-6">
                <UploadVideo
                  selectedFile={topicExplainVideoFile}
                  setSelectedFile={settopicExplainVideoFile}
                  preview={topicExplainPreview}
                  handleFileChange={handleExplanVideo}
                  uploadFunc={uploadTopicFunc}
                  headingText="This is How I Teach"
                  loader={upload2ndLoader}
                  addedVideo={addedVideo2}
                />
              </div>
            </div>
            <div className="text-center p-5">
              <button className="btn btn-success" onClick={() => teacherFormSubmitFunc()}>
                Submit Information
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loginSuccessNormal: state.feedRed.loginSuccessNormal,
});

export default connect(mapStateToProps, {
  doLogin,
})(RecruitmentTab);
